import { useEffect, useState } from 'react';
import {
  QuestionWrapper,
  useFormField,
  type FieldSchema,
  type Group,
} from '@stepform';

interface NameAnswer {
  first: { value: string };
  last: { value: string };
}

function parseNameAnswer(answer: unknown): NameAnswer {
  const parts = String(answer ?? '').trim().split(/\s+/).filter(Boolean);

  return {
    first: { value: parts[0] ?? '' },
    last: { value: parts.slice(1).join(' ') },
  };
}

export function NameField({ fieldSchema, group }: { fieldSchema: FieldSchema; group: Group }) {
  const field = useFormField(fieldSchema, group);
  const [nameAnswer, setNameAnswer] = useState<NameAnswer>(() => parseNameAnswer(field.answer));

  useEffect(() => {
    const answer = [nameAnswer.first.value, nameAnswer.last.value].join(' ').trim();
    field.setAnswer(answer);
  }, [nameAnswer, field]);

  if (!field.show) {
    return null;
  }

  return (
    <QuestionWrapper {...field} fieldSchema={fieldSchema}>
      <div className="answer-group answer-group--stacked">
        <div className="answer">
          <label className="small-label">
            First name
            <input
              type="text"
              className="text"
              value={nameAnswer.first.value}
              onChange={(e) =>
                setNameAnswer((current) => ({
                  ...current,
                  first: { value: e.target.value },
                }))
              }
              name={`${field.question.id}-first`}
              id={`${field.question.id}-first`}
              autoComplete="given-name"
            />
          </label>
        </div>
        <div className="answer">
          <label className="small-label">
            Last name
            <input
              type="text"
              className="text"
              value={nameAnswer.last.value}
              onChange={(e) =>
                setNameAnswer((current) => ({
                  ...current,
                  last: { value: e.target.value },
                }))
              }
              name={`${field.question.id}-last`}
              id={`${field.question.id}-last`}
              autoComplete="family-name"
            />
          </label>
        </div>
      </div>
    </QuestionWrapper>
  );
}
